module.exports = __webpack_public_path__ + "static/media/congratulations-city.57ba07c4.svg";